import { LeadInterface } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK - ../../../../apps/server/src/API/leads/leads.Controller.ts
export class LeadsAPI {
  static async getLeads() {
    return APIService.Server.get<LeadInterface[]>("/leads");
  }

  static async getLead(orgId: number, leadId: number) {
    return APIService.Server.get<LeadInterface>(`/leads/org/${orgId}/lead/${leadId}`);
  }

  static async getLeadsByLocationId(orgId: number, locationId: number) {
    return APIService.Server.get<LeadInterface[]>(`/leads/org/${orgId}/location/${locationId}`);
  }

  static async createLead(orgId: number, lead?: Partial<LeadInterface>) {
    return APIService.Server.post<LeadInterface>(`/leads/org/${orgId}/lead`, lead);
  }

  static async createLeads(orgId: number, leads?: Partial<LeadInterface>[]) {
    return APIService.Server.post<LeadInterface[]>(`/leads/org/${orgId}/leads`, leads);
  }

  static async updateLeads(orgId: number, leads: Partial<LeadInterface>[]) {
    return APIService.Server.put<LeadInterface[]>(`/leads/org/${orgId}/leads`, leads);
  }

  static async deleteLeads(orgId: number, leadIds: number[]) {
    return APIService.Server.delete<LeadInterface[]>(`/leads/org/${orgId}/leads`, null, leadIds);
  }
}
